import { DEFER_ACTION } from 'stash/actions/deferredActions.js';

const deferredActions = (state = {}, action) => {
	switch (action.type) {
		case DEFER_ACTION: {
			return {
				...state,
				[action.actionKey]: action.deferredAction,
			};
		}

		default:
			return state;
	}
};

export default deferredActions;
